module.exports = __webpack_public_path__ + "img/three3Red.985ff8f5.jpg";